import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useToastStore = defineStore('toast', () => {
  const areToastsHidden = ref(false);

  function hideToasts() {
    areToastsHidden.value = true;
  }

  function showToasts() {
    areToastsHidden.value = false;
  }

  return {
    areToastsHidden,
    hideToasts,
    showToasts,
  };
});
